// This needs to be separated from persistor logic file to avoid circular deps
export const SERVER_API_PERSIST_KEY = 'serverApi-1'
export const FEATURES_PERSIST_KEY = 'features-4'
